<template>
  <div>
    <div class="hit-html-h3">{{ $tc("message.invitation", 1) }}</div>

    <div class="hit-form-group">
      <div class="hit-input-group">
        <div class="hit-input-group-addon">
          <hit_icon :id="'envelope'" />
        </div>
        <input type="text"  class="hit-form-control" v-model="email" v-bind:placeholder="$t('message.add',{name: $t('message.email')})">
      </div>
    </div>

    <div class="hit-form-group">
      <ckeditor id="imprint" :editor="editor" v-model="text" :config="editorConfig"></ckeditor>
    </div>

    <div class="hit-form-group" v-if="success">
      <div class="hit-alert hit-alert-success"><div> {{ $t("message.successfullSendet") }} (<hit_icon :id="'envelope'" /> {{ email }})</div></div>
    </div>

    <div class="hit-form-group">
      <a href="#" class="hit-btn hit-btn-success" v-if="check_mail(email)"  v-on:click.prevent="send_mail()">{{ $t("message.send") }}</a>
    </div>
  </div>
</template>

<script>

import ClassicEditor from '@ckeditor/ckeditor5-build-classic'
import '@ckeditor/ckeditor5-build-classic/build/translations/de'

export default{
  props: { edit: Object},

  data () {
    var data = this.$store.getters.boards[this.edit.row]

    var url = this.$get_url().www_url + this.$router.resolve({ name: 'landingpage', params: {boardID: data.ID, username: this.$store.getters.user.username, lang: this.$store.getters.lang} }).href
    url = '<a href="' + url + '" target="_blank">' + url + '</a>'

    if (data.pass) { url += ' (' + this.$t('message.password') + ' = <b>' + data.pass + '</b>)' }

    var name = this.$store.getters.user.first_name + ' ' + this.$store.getters.user.last_name

    return {
      data: data,
      success: false,
      email: '',
      text: this.$nl2br(this.$t('email.invitationEmail.text', {board: data.name, link: url, name})),
      editor: ClassicEditor,
      editorConfig: {
        toolbar: [ 'heading', '|', 'bold', 'italic', '|', 'link', '|', 'bulletedList', 'numberedList' ],
        language: 'de'
      }
    }
  },

  watch: {
    email () { this.success = false }
  },

  methods: {

    send_mail () {
      var send = {
        user: this.$store.getters.user.md5_id,
        data: {
          email: {
            text: this.text,
            title: this.$tc('message.invitation', 1) + ': ' + this.$store.getters.boards[this.edit.row].name,
            to: this.email
          }
        }
      }

      this.$store.dispatch('set_invitation', send)

      setTimeout(function () {
        this.email = ''
      }.bind(this), 3000)

      this.success = true
    },

    check_mail (email) {
      var re = /\S+@\S+\.\S+/
      return re.test(email)
    }

  }

}
</script>
